export interface IQuestion {
  id: string
  name: string
  options?: IQuestionOption[]
  textarea?: boolean
}

export interface IQuestionOption {
  id: string
  name: string
  subQuestion?: IQuestion
  textarea?: boolean
  defaultLabel?: boolean
}

export interface ISurvey {
  id: string
  name: string
  questions: IQuestion[]
}

const aboutUsSurvey: ISurvey = {
  id: 'surveyAboutUs',
  name: 'About us survey',
  questions: [
    {
      id: '1',
      name: 'How did you find out about Vacation Tracker?',
      options: [
        {
          id: '1-1',
          name: 'GoogleSearch',
          subQuestion: {
            id: '1-1-1',
            name: 'What did you search for on Google (e.g. "vacation tracking")?',
            textarea: true,
          },
        },
        {
          id: '1-2',
          name: 'AI',
          subQuestion: {
            id: '1-2-1',
            name: 'What was your search question?',
            textarea: true,
          },
        },
        {
          id: '1-3',
          name: 'Saw a video',
          subQuestion: {
            id: '1-3-1',
            name: 'Which platform?',
            textarea: true,
          },
        },
        {
          id: '1-4',
          name: 'AppStore',
        },
        {
          id: '1-5',
          name: 'Social Media',
          subQuestion: {
            id: '1-5-1',
            name: 'Which platform?',
            textarea: true,
          },
        },
        {
          id: '1-6',
          name: 'Recommendation',
          subQuestion: {
            id: '1-6-1',
            name: "That's great! Who recommended us?",
            options: [
              {
                id: '1-6-1-1',
                name: 'A colleague or friend',
              },
              {
                id: '1-6-1-2',
                name: 'Another company suggested it',
              },
              {
                id: '1-6-1-3',
                name: 'I have used it in the past',
              },
            ],
          },
        },
        {
          id: '1-7',
          name: 'Other',
          textarea: true,
          defaultLabel: true,
        },
      ],
    },
  ],
}

export default aboutUsSurvey
